// extracted by mini-css-extract-plugin
export default {"background":"styleModule_background__LyXnJ","homeIcon":"styleModule_homeIcon__3Zoid"};